export class LineItemModifier {
    constructor(
        public id: string,
        public productId: string,
        public skuId: string,
        public name: string,
        public amount: number,
        public quantity: number,
        public dateCreated: Date,
        public dateUpdated: Date
    ) {}
}

export const POSTAL_DELIVERY_EXTERNAL_REFERENCE = 'voucher-postal-delivery'

export class LineItem {
    constructor(
        public id: string,
        public productId: string,
        public skuId: string,
        public name: string,
        public amount: number,
        public quantity: number,
        public modifiers: LineItemModifier[],
        public externalReference: string | null,
        public dateCreated: Date,
        public dateUpdated: Date,
        public customerRefundableUntil: Date | null = null,
        public paidOnline: boolean = true,
    ) { }

    unitAmount(): number {
        if (!this.paidOnline) {
            return 0
        }
        return this.amount + this.modifiers.reduce((total, modifier) => total + modifier.amount * modifier.quantity, 0)
    }

    get isPostalDeliveryFee(): boolean {
        return this.externalReference === POSTAL_DELIVERY_EXTERNAL_REFERENCE
    }
}
